import React, { useCallback, useState } from 'react';
import { ModalBody, ConfirmationPageModal, HoverAnimationBtn } from './styles';
import { CONFIRMATION_PAGE_MODAL } from './translationValues';
import { withTranslation, useTranslation } from 'react-i18next';
import GridSelectionInterface from '../Grid/GridSelectionInterface';
import {
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
  useDocumentContext,
} from '../../context/complexDocumentContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { STATIC_TABLE_BLOCK } from '../../utils/complexDocumentConstants';
import { v4 as uuidv4 } from 'uuid';

const NAMESPACES = ['CONFIRMATION_PAGE_MODAL'];
const tableElementContent = {
  rowSpan: 1,
  columnSpan: 1,
  style: {
    verticalAlignment: 'center',
    horizontalAlignment: 'center',
    border: {
      thickness: 1,
      borderStyle: 'SOLID',
      borderColor: '#000000',
      left: true,
      top: true,
      bottom: true,
      right: true,
    },
    padding: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
    },
    backgroundColor: '#00000000'
  },
  contents: [],
};

const generateTableData = async ({ rows, cols, tableElementContent }) => {
  const tasks = [];
  for (let i = 1; i <= rows; i++) {
    for (let j = 1; j <= cols; j++) {
      tasks.push({ row: i, column: j, ...tableElementContent, uuid: uuidv4() });
    }
  }
  return await Promise.all(tasks);
};

const GridSelectionInterfaceModal = () => {
  const { t } = useTranslation(NAMESPACES);
  const [loading, setLoading] = useState(false);
  const gridLayoutBlockSelector = useCallback(store => {
    return store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GRID_LAYOUT_BLOCK];
  }, []);
  const [gridLayoutBlockInfo, methods] = useDocumentContext(
    gridLayoutBlockSelector,
    'ConfirmationPageModal',
  );

  const [, updateArtboard] = useArtboardContext(store => null, '');

  let visible = gridLayoutBlockInfo ? Object.keys(gridLayoutBlockInfo).length > 0 : false;

  const handleSelectionChange = async ({ rows, cols }) => {
    const {
      uuid,
      pageId,
      draggedItem,
      dropType,
      dropItem,
      currentPageId,
    } = gridLayoutBlockInfo;
    let dragItem = Object.assign({}, draggedItem);
    const tableContents = await generateTableData({ rows, cols, tableElementContent });
    dragItem.element.elementDetails.style.height = 40 * rows;
    dragItem.element.elementDetails.style.tableProperties.rows = rows;
    dragItem.element.elementDetails.style.tableProperties.columns = cols;
    dragItem.element.elementDetails.style.tableProperties.columnWidths = Array(cols).fill(
      100 / cols,
    );
    dragItem.element.elementDetails.contents = tableContents;
    dragItem.element.elementDetails.style.tableProperties.rowHeights = Array(rows).fill(40);

    const newBlockUUID = methods.setPage('addBlock', {
      uuid,
      block: { ...dragItem.element.elementDetails },
      pageId,
      dropType,
      dropItem,
      currentPageId,
    });
    if (newBlockUUID) {
      requestAnimationFrame(() => {
        updateArtboard({
          [CONTEXT_KEYS.CURRENT_BLOCK]: newBlockUUID,
          [CONTEXT_KEYS.CURRENT_BLOCK_TYPE]: STATIC_TABLE_BLOCK,
          [CONTEXT_KEYS.CURRENT_PAGE]: uuid,
          [CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU]: true,
          [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
        });
      });
    }

    setLoading(false);
    onCancel();
  };

  const onCancel = () => {
    methods.set({ [COMPLEX_DOCUMENT_CONTEXT_KEYS.GRID_LAYOUT_BLOCK]: undefined });
  };

  if (!visible) return <div />;

  return (
    <ConfirmationPageModal
      title={ t(
        CONFIRMATION_PAGE_MODAL.GRID_SELECTION.key,
        CONFIRMATION_PAGE_MODAL.GRID_SELECTION.value,
      )}
      centered
      visible={visible}
      footer={null}
      width={420}
      modalBodyPadding={'0px 34px 34px 34px'}
      style={{ width: '745px' }}
      ConfirmationPageDialog={true}
      onCancel={onCancel}
      maskClosable={false}
      className="ConfirmationPageModal"
      maskstyle={{ backgroundcolor: 'rgba(0,0,0,0.01)' }}
      transparentCard={false}
    >
      <ModalBody>
        <div className="GridSelectionInterfaceModal">
          <div className="content-wrapper">
            <GridSelectionInterface
              rows={10}
              columns={10}
              onSelectionChange={handleSelectionChange}
              setLoading={setLoading}
              loading={loading}
            />
          </div>
        </div>
      </ModalBody>
    </ConfirmationPageModal>
  );
};
export default withTranslation(NAMESPACES)(GridSelectionInterfaceModal);
